/* axtlan-dealbar.js - rotating deals bar of the Speclang shop (owner 2026-10-08), the same behaviour as ax-dealbar.js on speclang.pro / app / fact / form.
   Axtlan offers: today's products of shop.axtlan.mx read from its public /collections/<handle>/products.json (GET, no cookies); the links get the
   product. Speclang offers are rendered by Liquid from this shop. One offer at a time, every 5 s; pauses on hover / keyboard focus; no rotation with
   reduced motion or experience mode Off (then all offers stay in one scrollable row). Visual only: no storage. */
(() => {
  "use strict";
  const bar = document.querySelector("[data-ax-dealbar]");
  if (!bar || bar.dataset.axReady) return;
  bar.dataset.axReady = "1";
  const list = bar.querySelector(".ax-dealbar__list"); const dots = bar.querySelector(".ax-dealbar__dots");
  const base = bar.dataset.axBase || ""; const utm = bar.dataset.axUtm || "";
  list.querySelectorAll('[data-shop="axtlan"][data-collection]').forEach(async (li) => {
    try {
      const r = await fetch(`${base}/collections/${li.dataset.collection}/products.json?limit=1`, { mode: "cors", credentials: "omit" });
      if (!r.ok) return;
      const p = (await r.json()).products?.[0];
      if (!p) return;
      li.querySelector(".ax-dealbar__name").textContent = p.title.replace(/\s+-\s+(Digital (Download|Album)|Descarga digital|Álbum digital).*$/i, "").replace(/^Axtlan\s+/i, "");
      li.querySelector("a").href = `${base}/products/${p.handle}?${utm}`;
    } catch { /* keep the static offer */ }
  });
  const items = [...list.children];
  const still = matchMedia("(prefers-reduced-motion: reduce)").matches || document.documentElement.dataset.axMode === "off";
  if (items.length < 2 || still) return;
  bar.classList.add("is-rotating");
  let i = 0, timer = 0;
  const show = (n) => {
    i = (n + items.length) % items.length;
    items.forEach((li, k) => li.classList.toggle("is-current", k === i));
    dots.querySelectorAll("button").forEach((b, k) => b.setAttribute("aria-current", String(k === i)));
  };
  const restart = () => { clearInterval(timer); timer = setInterval(() => show(i + 1), 5000); };
  dots.replaceChildren(...items.map((li, k) => {
    const b = document.createElement("button");
    b.type = "button";
    b.setAttribute("aria-label", `${li.querySelector(".ax-dealbar__shop").textContent} \u00b7 ${li.querySelector(".ax-dealbar__label").textContent}`);
    b.addEventListener("click", () => { show(k); restart(); });
    return b;
  }));
  bar.addEventListener("mouseenter", () => clearInterval(timer)); bar.addEventListener("mouseleave", restart);
  bar.addEventListener("focusin", () => clearInterval(timer)); bar.addEventListener("focusout", restart);
  show(0); restart();
})();
